var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden lg:block absolute center-x top-0 w-1 h-0 bg-gray-bright transition-all duration-700"})}
var staticRenderFns = []

export { render, staticRenderFns }